import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const Dance = () => {
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" }, 
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-dance1.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Facilities" breadEnd="Learning Approach" breadMid="Dance" />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-xl-12 mb-4">
                            <h4 className="color-red">Dance</h4>
                            <div class="lab-heading mb-4">
                                <div class="lab-btn" id="mb-lab-btn"><span>PERFORMING ARTS</span></div>
                                <ul class="labs-list">
                                    <li><a class="" href="/music">Music</a></li>
                                    <li><a class="inc-tlink-active" href="/dance">Dance</a></li> 
                                </ul>
                            </div>  

<img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/dance1.jpg" className="float-end wid-500 m-2" alt="Lotus Valley Gurgaon" />
                            <p>We at Lotus Valley International School believe that dancing in all its forms must be included in the curriculum of all noble education. Dancing with the feet, with ideas, with words and with expressions sets our education at a pace apart. Various dance forms such as Lyrical choreography with contemporary form, Indian classical dance forms like Kathak, Bharatnatyam, Odishi and Chhao; Folk Dance forms like Chirmi, Bhangra, Lavni, Ghumanr, Kalbeliya and Dandiya; Western Style dance forms like Hip Hop, Freestyle, Contemporary are majorly taught to the learners. The dance studios of Pre-Primary, Primary and Senior wings are fully equipped, and are spacious enough for organizing various dance related activities and competitions.</p>
                            

                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Dance